import _ from 'underscore';
import { logTrace } from './logger';
import { APIScenarioNames, APINotificationLogKeys } from '../constants';

let externalNotificationsMapping = {};
let onChangeHandler;

const logNotifications = (scenarioName, notifications, options) => {
  const logContent = JSON.stringify(_.map(
    notifications,
    notification => _.pick(notification, APINotificationLogKeys)
  ));
  // trace options in log only when it's defined
  const message = _.isObject(options) ?
    `Content: ${logContent}; Options: ${JSON.stringify(options)};` : logContent;
  logTrace(scenarioName, message);
};

const getAll = () => _.values(externalNotificationsMapping);

const handleChange = () => onChangeHandler
  && onChangeHandler(getAll());

const onChange = (handler) => {
  onChangeHandler = handler;
};

const unbind = (handler) => {
  if (onChangeHandler === handler) {
    onChangeHandler = undefined;
  }
};

// If the caller is from queue, isInternal should be true;
// for external callers, isInternal is false by default.
const removeByIds = (ids, isInternal = false) => {
  const externalNotifications = getAll();

  externalNotificationsMapping = _.omit(externalNotificationsMapping, ids);
  handleChange();
  logNotifications(
    isInternal ? APIScenarioNames.removeExByIdsInternal : APIScenarioNames.removeExByIds,
    _.filter(externalNotifications, ({ id }) => _.contains(ids, id)),
    { ids }
  );
};

const removeAll = (isInternal = false) => {
  const externalNotifications = getAll();

  externalNotificationsMapping = {};
  handleChange();
  logNotifications(
    isInternal ? APIScenarioNames.removeAllExInternal : APIScenarioNames.removeAllEx,
    externalNotifications,
    { removeAll: true }
  );
};

// This function is to remove notifications by giving filter options
// remove all notifications by default if options undefined
const remove = (options = { removeAll: true }, isInternal = false) => {
  const externalNotifications = getAll();

  if (options.removeAll) {
    externalNotificationsMapping = {};
  } else {
    if (options.ids) {
      externalNotificationsMapping = _.omit(externalNotificationsMapping, options.ids);
    }
    if (options.notificationSources) {
      externalNotificationsMapping = _.omit(
        externalNotificationsMapping,
        item => _.contains(options.notificationSources, item.notificationSource)
      );
    }
    if (options.severities) {
      externalNotificationsMapping = _.omit(
        externalNotificationsMapping,
        item => _.contains(options.severities, item.severity)
      );
    }
  }
  handleChange();
  logNotifications(
    isInternal ? APIScenarioNames.removeExInternal : APIScenarioNames.removeEx,
    _.filter(
      externalNotifications,
      ({ id }) => !_.contains(_.keys(externalNotificationsMapping), id)
    ),
    options
  );
};

const dismissAll = () => {
  const externalNotifications = getAll();

  if (externalNotifications.length > 0) {
    removeAll(true);
    _.each(externalNotifications, ({ dismissCallback }) => dismissCallback());
  }
};

const show = (notifications) => {
  const notificationsToLog = [];

  externalNotificationsMapping = {
    ...externalNotificationsMapping,
    ..._.reduce(notifications, (memo, notification) => {
      const dismissCallback = notification.dismissAction || _.noop;

      notificationsToLog.push(notification);

      return {
        ...memo,
        [notification.id]: {
          ...notification,
          dismissAction: () => {
            removeByIds([notification.id], true);
            dismissCallback();
          },
          dismissCallback,
        },
      };
    }, {}),
  };
  handleChange();
  logNotifications(APIScenarioNames.showEx, notificationsToLog);
};

export {
  // for internal use
  getAll, dismissAll, onChange, unbind,

  // for external use
  show, removeByIds, removeAll, remove,
};
